export default "__VITE_ASSET__DsR8M6ds__"